import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import './index.css'
import App from './App.tsx'
import { env } from '@/lib/env'

if (import.meta.env.PROD) {
  Sentry.init({
    dsn: env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    // Drop noisy errors at the SDK before ingest. Mirrors the `ignoreErrors`
    // slot in frontend/app/_layout.tsx.
    ignoreErrors: [],
  })
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
